// extracted by mini-css-extract-plugin
export default {"wrapper":"CalendarEventFilterBlock_wrapper__aA9SK"};